import { Icon, Breadcrumb, IBreadcrumbItem } from '@fluentui/react';
import { useFileBrowserStore } from '@/hooks';

export function Breadcrumbs() {
  const { getBreadcrumbs, navigate, goHome, currentSiteId, sites } = useFileBrowserStore();
  const breadcrumbs = getBreadcrumbs();
  const siteName = sites.find((s) => s.id === currentSiteId)?.name || 'Site';

  // Always Home > [site]: the tree (including the in-place search filter) shows
  // depth directly, so the breadcrumb stays at the site level.
  const crumbs = breadcrumbs.slice(0, 1);
  const items: IBreadcrumbItem[] = crumbs.map((crumb, index) => {
    const isLast = index === crumbs.length - 1;
    return {
      key: crumb.path || 'root',
      text: index === 0 ? siteName : crumb.name,
      isCurrentItem: isLast,
      onClick: isLast ? undefined : () => navigate(crumb.path),
    };
  });

  return (
    <div className="breadcrumbs">
      {/* Home -> back to the site picker (all sites) */}
      <button className="breadcrumb-item home" onClick={goHome} title="All sites">
        <Icon iconName="Home" className="breadcrumb-home-icon" />
      </button>
      <Icon iconName="ChevronRight" className="breadcrumb-home-chevron" />

      <Breadcrumb
        items={items}
        maxDisplayedItems={3}
        overflowIndex={items.length > 1 ? 1 : 0}
        ariaLabel="Folder path"
        overflowAriaLabel="More folders"
        className="breadcrumb-fluent"
        // Shared 32px/16px scale; the current item renders as .item (semibold),
        // clickable ancestors as .itemLink.
        styles={{
          root: { margin: 0 },
          item: { fontSize: 13, fontWeight: 600, height: 32, lineHeight: '32px' },
          itemLink: {
            fontSize: 13,
            fontWeight: 400,
            height: 32,
            lineHeight: '32px',
            padding: '0 6px',
          },
          overflowButton: { height: 32 },
          chevron: { fontSize: 10 },
        }}
      />
    </div>
  );
}
